import React from "react";
import { Header } from "semantic-ui-react";
import "./Title.css";

export default function Title() {
  return(
    <div className="fixed_header">
      <Header textAlign="center" as="h4"> 
        Playground
      </Header>
      </div>
    // <Grid>
    //   <Grid.Row columns={3}>
    //       <Grid.Column width={3}>
    //           <div style={{paddingLeft: 10, paddingTop: 10}}>
    //               <Image src={logo} size="tiny"/>
    //           </div>
    //       </Grid.Column>  

    //       <Grid.Column width={4}>
    //       </Grid.Column>

    //       <Grid.Column width={9}>
    //           <div style={{paddingTop: 10}}>
    //               <Header as='h1'><span style={{color: "#F60157"}}>Envoy</span></Header>
    //           </div>
    //       </Grid.Column>
    //   </Grid.Row>
    // </Grid>    
  )
}
